<div class="card">
  <div class="card-body">
    @if (canNavigateToUsers) {
      <a [routerLink]="'/users'" class="card-title h5">
        <span class="material-symbols-outlined">person</span>
        <span style="vertical-align: middle" class="ms-2">{{ configuration.title }}</span>
      </a>
    } @else {
      <div class="card-title h5">
        <span class="material-symbols-outlined">person</span>
        <span style="vertical-align: middle" class="ms-2">{{ configuration.title }}</span>
      </div>
    }
    @if (configuration.description) {
      <h6 class="card-subtitle mb-2 mt-2 text-muted">{{ configuration.description }}</h6>
    }
    @if (!isLoading) {
      <app-card-bar [title]="'user.title'" [data]="workerData"></app-card-bar>
    }
    <app-loading-indicator [loading]="isLoading"></app-loading-indicator>
  </div>
</div>
